module.exports = __webpack_public_path__ + "static/media/payout.619f2751.svg";